import styled from 'styled-components';
import { DatePicker } from 'antd';

export const DateRangePicker = styled(DatePicker.RangePicker)`
  height: 30px !important;
  padding: 2px 8px !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 8px !important;
  background: white !important;
  font-family: 'Poppins' sans-serif;
  font-size: 14px;
  color: #333;
  min-width: 120px;

  display: flex !important;
  align-items: center;

  @media (max-width: 768px) {
    width: 100% !important;
  }

  .ant-picker-input > input {
    font-family: 'Poppins';
    height: 28px;
  }

  .ant-picker-suffix {
    order: -1; /* move calendar icon to left */
    margin-right: 4px;
    margin-left: 0;
  }
`;
